import React from 'react'
import { SortableTableHeader } from '../../../../../app/components/statelessDataTable/components/tableColumn'
import LocationsAffected from '../../../../../common/components/locationsAffected'
import LocationsAffectedAddressModal from '../../../locationsAffected/locationsModal/table'
import ExpandableTruncatedText from '../../../../../app/components/ExpandableTruncatedText'
import PAID_LEAVE from '../../../../constants'
import { StyledSpan } from '../../../../../theme/Global'

const paidLeaveLocationsTableColumns = ({
  sortOptions,
  filterOptions,
  eventHandlers
}) => {
  const commonColumns = [
    {
      Header: () => (
        <SortableTableHeader
          {...{
            field: PAID_LEAVE.TABLE_HEADERS.JURISDICTION_NAME.ACCESSOR,
            text: PAID_LEAVE.TABLE_HEADERS.JURISDICTION_NAME.HEADER,
            sortOptions,
            eventHandlers
          }}
        />
      ),
      accessor: PAID_LEAVE.TABLE_HEADERS.JURISDICTION_NAME.ACCESSOR,
      Cell: ({ cell }) => <StyledSpan>{cell.row.original.jurisdiction.name}</StyledSpan>,
      width: 115,
      minWidth: 0,
      maxWidth: 0,
      canSort: true,
      className: 'sticky',
      headerClassName: 'sticky'
    },
    {
      Header: () => (
        <SortableTableHeader
          {...{
            field: PAID_LEAVE.TABLE_HEADERS.TYPE.ACCESSOR,
            text: PAID_LEAVE.TABLE_HEADERS.TYPE.HEADER,
            sortOptions,
            eventHandlers
          }}
        />
      ),
      accessor: PAID_LEAVE.TABLE_HEADERS.TYPE.ACCESSOR,
      Cell: ({ cell }) => <StyledSpan>{cell.row.original.jurisdiction.type}</StyledSpan>,
      width: 50,
      minWidth: 0,
      maxWidth: 0,
      canSort: true
    },
    {
      Header: () => (
        <SortableTableHeader
          {...{
            field: PAID_LEAVE.TABLE_HEADERS.LOCATIONS_AFFECTED.ACCESSOR,
            text: PAID_LEAVE.TABLE_HEADERS.LOCATIONS_AFFECTED.HEADER,
            sortOptions,
            eventHandlers
          }}
        />
      ),
      accessor: PAID_LEAVE.TABLE_HEADERS.LOCATIONS_AFFECTED.ACCESSOR,
      Cell: ({ cell }) => (
        <LocationsAffected
          {...{
            data: {
              jurisdiction: cell.row.original.jurisdiction,
              locations: cell.row.original.locationsAffected
                ? cell.row.original.locationsAffected.length : null
            },
            canOpen: true,
            modal: <LocationsAffectedAddressModal locations={cell.row.original.locationsAffected} />
          }}
        />
      ),
      width: 115,
      minWidth: 0,
      maxWidth: 0,
      canSort: true
    }
  ]

  const paidLeaveMiscellaneousColumns = [
    {
      Header: PAID_LEAVE.TYPES.PAID_LEAVE.TOPICS.ACCRUAL_RATE.HEADER,
      width: 280,
      accessor: PAID_LEAVE.TYPES.PAID_LEAVE.TOPICS.ACCRUAL_RATE.ACCESSOR,
      Cell: ({ cell }) => {
        const topic = cell.row.original.topics[PAID_LEAVE.TYPES.PAID_LEAVE.TOPICS.ACCRUAL_RATE.HEADER]
        return (
          <ExpandableTruncatedText
            {...{
              text: topic || '',
              truncateNumber: 128
            }}
          />
        )
      }
    },
    {
      Header: PAID_LEAVE.TYPES.PAID_LEAVE.TOPICS.WEEKS_ALLOWED_PER_TYPE_OF_LEAVE.HEADER,
      width: 175,
      accessor: PAID_LEAVE.TYPES.PAID_LEAVE.TOPICS.WEEKS_ALLOWED_PER_TYPE_OF_LEAVE.ACCESSOR,
      Cell: ({ cell }) => {
        const topic = cell.row.original.topics[PAID_LEAVE.TYPES.PAID_LEAVE.TOPICS.WEEKS_ALLOWED_PER_TYPE_OF_LEAVE.HEADER]
        return (
          <ExpandableTruncatedText
            {...{
              text: topic || '',
              truncateNumber: 84
            }}
          />
        )
      }
    },
    {
      Header: PAID_LEAVE.TYPES.PAID_LEAVE.TOPICS.MAX_ACCRUAL_CAP.HEADER,
      width: 150,
      accessor: PAID_LEAVE.TYPES.PAID_LEAVE.TOPICS.MAX_ACCRUAL_CAP.ACCESSOR,
      Cell: ({ cell }) => {
        const topic = cell.row.original.topics[PAID_LEAVE.TYPES.PAID_LEAVE.TOPICS.MAX_ACCRUAL_CAP.HEADER]
        return (
          <ExpandableTruncatedText
            {...{
              text: topic || '',
              truncateNumber: 45
            }}
          />
        )
      }
    },
    {
      Header: PAID_LEAVE.TYPES.PAID_LEAVE.TOPICS.WAITING_PERIOD.HEADER,
      width: 160,
      accessor: PAID_LEAVE.TYPES.PAID_LEAVE.TOPICS.WAITING_PERIOD.ACCESSOR,
      Cell: ({ cell }) => {
        const topic = cell.row.original.topics[PAID_LEAVE.TYPES.PAID_LEAVE.TOPICS.WAITING_PERIOD.HEADER]
        return (
          <ExpandableTruncatedText
            {...{
              text: topic || '',
              truncateNumber: 45
            }}
          />
        )
      }
    },
    {
      Header: PAID_LEAVE.TYPES.PAID_LEAVE.TOPICS.COVERED_FAMILY_MEMBER.HEADER,
      width: 150,
      accessor: PAID_LEAVE.TYPES.PAID_LEAVE.TOPICS.COVERED_FAMILY_MEMBER.ACCESSOR,
      Cell: ({ cell }) => {
        const topic = cell.row.original.topics[PAID_LEAVE.TYPES.PAID_LEAVE.TOPICS.COVERED_FAMILY_MEMBER.HEADER]
        return (
          <ExpandableTruncatedText
            {...{
              text: topic || '',
              truncateNumber: 45
            }}
          />
        )
      }
    },
    {
      Header: PAID_LEAVE.TYPES.PAID_LEAVE.TOPICS.ELIGIBLE_REASONS_FOR_LEAVE.HEADER,
      width: 180,
      accessor: PAID_LEAVE.TYPES.PAID_LEAVE.TOPICS.ELIGIBLE_REASONS_FOR_LEAVE.ACCESSOR,
      Cell: ({ cell }) => {
        const topic = cell.row.original.topics[PAID_LEAVE.TYPES.PAID_LEAVE.TOPICS.ELIGIBLE_REASONS_FOR_LEAVE.HEADER]
        return (
          <ExpandableTruncatedText
            {...{
              text: topic || '',
              truncateNumber: 45
            }}
          />
        )
      }
    }
  ]

  const paidSickLeaveColumns = [
    {
      Header: PAID_LEAVE.TYPES.PAID_SICK_LEAVE.TOPICS.ACCRUAL_RATE.HEADER,
      width: 280,
      accessor: PAID_LEAVE.TYPES.PAID_SICK_LEAVE.TOPICS.ACCRUAL_RATE.ACCESSOR,
      Cell: ({ cell }) => {
        const topic = cell.row.original.topics[PAID_LEAVE.TYPES.PAID_SICK_LEAVE.TOPICS.ACCRUAL_RATE.HEADER]
        return (
          <ExpandableTruncatedText
            {...{
              text: topic || '',
              truncateNumber: 128
            }}
          />
        )
      }
    },
    {
      Header: PAID_LEAVE.TYPES.PAID_SICK_LEAVE.TOPICS.DATE_ACCRUAL_BEGINS.HEADER,
      width: 175,
      accessor: PAID_LEAVE.TYPES.PAID_SICK_LEAVE.TOPICS.DATE_ACCRUAL_BEGINS.ACCESSOR,
      Cell: ({ cell }) => {
        const topic = cell.row.original.topics[PAID_LEAVE.TYPES.PAID_SICK_LEAVE.TOPICS.DATE_ACCRUAL_BEGINS.HEADER]
        return (
          <ExpandableTruncatedText
            {...{
              text: topic || '',
              truncateNumber: 84
            }}
          />
        )
      }
    },
    {
      Header: PAID_LEAVE.TYPES.PAID_SICK_LEAVE.TOPICS.MAX_USE_PER_YEAR.HEADER,
      width: 175,
      accessor: PAID_LEAVE.TYPES.PAID_SICK_LEAVE.TOPICS.MAX_USE_PER_YEAR.ACCESSOR,
      Cell: ({ cell }) => {
        const topic = cell.row.original.topics[PAID_LEAVE.TYPES.PAID_SICK_LEAVE.TOPICS.MAX_USE_PER_YEAR.HEADER]
        return (
          <ExpandableTruncatedText
            {...{
              text: topic || '',
              truncateNumber: 84
            }}
          />
        )
      }
    },
    {
      Header: PAID_LEAVE.TYPES.PAID_SICK_LEAVE.TOPICS.CARRYOVER.HEADER,
      width: 150,
      accessor: PAID_LEAVE.TYPES.PAID_SICK_LEAVE.TOPICS.CARRYOVER.ACCESSOR,
      Cell: ({ cell }) => {
        const topic = cell.row.original.topics[PAID_LEAVE.TYPES.PAID_SICK_LEAVE.TOPICS.CARRYOVER.HEADER]
        return (
          <ExpandableTruncatedText
            {...{
              text: topic || '',
              truncateNumber: 45
            }}
          />
        )
      }
    }
  ]

  const paidFamilyMedicalLeaveColumns = [
    {
      Header: PAID_LEAVE.TYPES.PAID_FAMILY_MEDICAL_LEAVE.TOPICS.WEEKS_ALLOWED.HEADER,
      width: 280,
      accessor: PAID_LEAVE.TYPES.PAID_FAMILY_MEDICAL_LEAVE.TOPICS.WEEKS_ALLOWED.ACCESSOR,
      Cell: ({ cell }) => {
        const topic = cell.row.original.topics[PAID_LEAVE.TYPES.PAID_FAMILY_MEDICAL_LEAVE.TOPICS.WEEKS_ALLOWED_PER_TYPE_OF_LEAVE.HEADER]
        return (
          <ExpandableTruncatedText
            {...{
              text: topic || '',
              truncateNumber: 128
            }}
          />
        )
      }
    },
    {
      Header: PAID_LEAVE.TYPES.PAID_FAMILY_MEDICAL_LEAVE.TOPICS.WAITING_PERIOD.HEADER,
      width: 175,
      accessor: PAID_LEAVE.TYPES.PAID_FAMILY_MEDICAL_LEAVE.TOPICS.WAITING_PERIOD.ACCESSOR,
      Cell: ({ cell }) => {
        const topic = cell.row.original.topics[PAID_LEAVE.TYPES.PAID_FAMILY_MEDICAL_LEAVE.TOPICS.WAITING_PERIOD.HEADER]
        return (
          <ExpandableTruncatedText
            {...{
              text: topic || '',
              truncateNumber: 84
            }}
          />
        )
      }
    },
    {
      Header: PAID_LEAVE.TYPES.PAID_FAMILY_MEDICAL_LEAVE.TOPICS.INTERMITTENT_USE.HEADER,
      width: 175,
      accessor: PAID_LEAVE.TYPES.PAID_FAMILY_MEDICAL_LEAVE.TOPICS.INTERMITTENT_USE.ACCESSOR,
      Cell: ({ cell }) => {
        const topic = cell.row.original.topics[PAID_LEAVE.TYPES.PAID_FAMILY_MEDICAL_LEAVE.TOPICS.INTERMITTENT_USE.HEADER]
        return (
          <ExpandableTruncatedText
            {...{
              text: topic || '',
              truncateNumber: 84
            }}
          />
        )
      }
    }
  ]

  let columns = []

  switch (filterOptions.paidLeaveType) {
    case PAID_LEAVE.TYPES.PAID_FAMILY_MEDICAL_LEAVE.JSON_VALUE:
      columns = commonColumns.concat(paidFamilyMedicalLeaveColumns)
      break
    case PAID_LEAVE.TYPES.PAID_SICK_LEAVE.JSON_VALUE:
      columns = commonColumns.concat(paidSickLeaveColumns)
      break
    default:
      columns = commonColumns.concat(paidLeaveMiscellaneousColumns)
      break
  }

  return columns
}

export default paidLeaveLocationsTableColumns
